import { render, staticRenderFns } from "./WebPartFormSubmitRunner.vue?vue&type=template&id=3b8c4f8c&"
import script from "./WebPartFormSubmitRunner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormSubmitRunner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b8c4f8c')) {
      api.createRecord('3b8c4f8c', component.options)
    } else {
      api.reload('3b8c4f8c', component.options)
    }
    module.hot.accept("./WebPartFormSubmitRunner.vue?vue&type=template&id=3b8c4f8c&", function () {
      api.rerender('3b8c4f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartFormSubmitRunner.vue"
export default component.exports